export const key = "onboarding.label.complete";
